"use client";

import { GetAdStats } from "@/actions/details/GetAdStats";
import { HIDE_SCROLLBAR_STYLE } from "@/app/layout/LayoutConstants";
import AdDetailModel from "@/models/AdDetailModel";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isbot } from "isbot";
import { FormatRelativeDate } from "@/actions/search/mappers/FormatRelativeDate";

export default function AdMeta({ ad }: { ad: AdDetailModel }) {
  const [adStats, setAdStats] = useState<{ views: number } | null>(null);

  useEffect(() => {
    (async () => {
      if (isbot(navigator.userAgent)) {
        return;
      }
      const stats = await GetAdStats(ad.id);
      setAdStats(stats);
    })();
  }, [ad.id]);

  return (
    <Box
      sx={(theme) => ({
        maxWidth: "100%",
        display: "flex",
        gap: 1,
        whiteSpace: "nowrap",
        overflow: "auto",
        color: "grey.600",
        alignItems: "center",
        ".MuiTypography-root": {
          ...theme.typography.body2,
        },
        ...HIDE_SCROLLBAR_STYLE,
      })}
    >
      {adStats ? (
        <>
          <Typography>{adStats.views} views</Typography>·
          <Typography>{FormatRelativeDate("updated", ad.updatedAt)}</Typography>
          ·
          <Typography>{FormatRelativeDate("created", ad.createdAt)}</Typography>
        </>
      ) : (
        <Typography>&nbsp;</Typography>
      )}
    </Box>
  );
}
